import React, { useEffect, useState } from "react";
import Layout from "../../components/Admin/AdminLayout";
import AdminHeader from "./component/AdminHeader";
import axios from "axios";
import { message } from "antd";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
// ✅ Quill toolbar and font settings
// ✅ Quill toolbar and font settings (same as Blog Admin)
const Font = Quill.import("formats/font");
Font.whitelist = [
  "sans-serif",
  "serif",
  "monospace",
  "poppins",
  "montserrat",
  "times-new-roman",
  "georgia",
];
Quill.register(Font, true);

// ✅ Add font styles dynamically
const customFontStyles = `
  .ql-editor .ql-font-poppins { font-family: 'Poppins', sans-serif; }
  .ql-editor .ql-font-montserrat { font-family: 'Montserrat', sans-serif; }
  .ql-editor .ql-font-times-new-roman { font-family: 'Times New Roman', serif; }
  .ql-editor .ql-font-georgia { font-family: 'Georgia', serif; }
`;
const styleTag = document.createElement("style");
styleTag.innerHTML = customFontStyles;
document.head.appendChild(styleTag);

// ✅ Enhanced toolbar (same as Blog Admin)
const modules = {
  toolbar: [
    [{ font: Font.whitelist }, { size: [] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    [{ header: "1" }, { header: "2" }, "blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
    [{ align: [] }],
    ["link", "image", "video"],
    ["clean"],
  ],
};

const formats = [
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "script",
  "header",
  "blockquote",
  "code-block",
  "list",
  "bullet",
  "indent",
  "align",
  "link",
  "image",
  "video",
];

const AddTravelThemePage = () => {
  const [loading, setLoading] = useState(false);
  const [themeName, setThemeName] = useState("");
  const [themeUrl, setThemeUrl] = useState(null);
  const [bannerUrls, setBannerUrls] = useState([]);
  const [overview, setOverview] = useState("");
  const [allThemes, setAllThemes] = useState(null);

  const [editId, setEditId] = useState(null);

  // Upload single thumbnail
  const uploadThumbnail = (image) => {
    if (!image) return message.error("Please select an image");
    if (image.type === "image/jpeg" || image.type === "image/png") {
      const data = new FormData();
      data.append("file", image);
      data.append("upload_preset", "tpn7r5e3");
      data.append("cloud_name", "dbjfrdaui");

      fetch("https://api.cloudinary.com/v1_1/dbjfrdaui/image/upload/", {
        method: "post",
        body: data,
      })
        .then((res) => res.json())
        .then((data) => setThemeUrl(data.secure_url))
        .catch((err) => message.error(err));
    } else {
      return message.error("Only jpeg/png allowed");
    }
  };

  // Upload multiple banners
  const uploadBanners = (images) => {
    if (!images || images.length === 0) return;
    [...images].forEach((image) => {
      if (image.type === "image/jpeg" || image.type === "image/png") {
        const data = new FormData();
        data.append("file", image);
        data.append("upload_preset", "tpn7r5e3");
        data.append("cloud_name", "dbjfrdaui");

        fetch("https://api.cloudinary.com/v1_1/dbjfrdaui/image/upload/", {
          method: "post",
          body: data,
        })
          .then((res) => res.json())
          .then((data) =>
            setBannerUrls((prev) => [...prev, data.secure_url])
          )
          .catch((err) => message.error(err));
      } else {
        message.error("Only jpeg/png allowed");
      }
    });
  };

  // Remove banner
  const removeBanner = (index) => {
    setBannerUrls(bannerUrls.filter((_, i) => i !== index));
  };

  // Get all travel themes
  const getAllThemes = async () => {
    try {
const res = await axios.get(`/api/travel-theme/get-all-travel-themes`);
      let arr = res.data.data;
      setAllThemes(arr.reverse());
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (allThemes === null) {
      getAllThemes();
    }
  }, []);

  // Submit form
  const submit = (e) => {
    e.preventDefault();
    if (!themeUrl) return message.error("Thumbnail is required");
    if (bannerUrls.length === 0)
      return message.error("At least one banner required");

    setLoading(true);

    const payload = {
      name: themeName,
      url: themeUrl,
      bannerImages: bannerUrls,
      overview,
    };

    if (editId) {
      // Update
      axios({
        method: "PUT",
        data: payload,
        withCredentials: true,
url: `/api/travel-theme/update-travel-theme/${editId}`,
      })
        .then((res) => {
          getAllThemes();
          resetForm();
          setTimeout(() => setLoading(false), 1000);
          message.success(res.data.message);
        })
        .catch((err) => {
          setTimeout(() => setLoading(false), 1000);
          console.log(err);
        });
    } else {
      // Add
      axios({
        method: "POST",
        data: payload,
        withCredentials: true,
url: `/api/travel-theme/add-travel-theme`,
      })
        .then((res) => {
          getAllThemes();
          resetForm();
          setTimeout(() => setLoading(false), 1000);
          message.success(res.data.message);
        })
        .catch((err) => {
          setTimeout(() => setLoading(false), 1000);
          console.log(err);
        });
    }
  };

  // Delete theme
  const deleteTheme = (id) => {
    axios({
      method: "POST",
      data: { id },
      withCredentials: true,
url: `/api/travel-theme/delete-travel-theme`,
    })
      .then((res) => {
        getAllThemes();
        setTimeout(() => setLoading(false), 1000);
        message.success(res.data.message);
      })
      .catch((err) => {
        setTimeout(() => setLoading(false), 1000);
        console.log(err);
      });
  };

  // Load data for edit
  const editTheme = (theme) => {
    setEditId(theme._id);
    setThemeName(theme.name);
    setThemeUrl(theme.url);
    setBannerUrls(theme.bannerImages || []);
    setOverview(theme.overview || "");
  };

  // Reset
  const resetForm = () => {
    setEditId(null);
    setThemeName("");
    setThemeUrl(null);
    setBannerUrls([]);
    setOverview("");
  };

  const OverviewText = ({ text }) => {
    const [expanded, setExpanded] = useState(false);
    const toggleExpand = () => setExpanded(!expanded);
    return (
      <div>
      <div
  style={{
    display: "-webkit-box",
    WebkitLineClamp: expanded ? "unset" : 4,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }}
  dangerouslySetInnerHTML={{ __html: text }}
></div>

        {text.length > 150 && (
          <button
            onClick={toggleExpand}
            style={{
              border: "none",
              background: "none",
              color: "#007bff",
              cursor: "pointer",
              padding: 0,
              marginTop: "5px",
            }}
          >
            {expanded ? "Read Less" : "Read More"}
          </button>
        )}
      </div>
    );
  };

  return (
    <Layout>
      <AdminHeader
        title="Add Travel Theme"
        redirect="/admin-dashboard"
        btnName="Add Trip"
        btnUrl="/add-trip"
        btnName2="Add Category"
        btnUrl2="/add-category"
      />

      <div className="Mon_font px-3 m-0 pb-4">
        <form
          className="row g-3 rounded border border-2 m-0 px-2 py-3"
          style={{ backgroundColor: "#f5f5f5" }}
          onSubmit={submit}
        >
          {/* Thumbnail preview */}
          {themeUrl && (
            <div className="m-0">
              <img
                className="border rounded bg-white m-0 p-1 mb-2"
                width={100}
                src={themeUrl}
                alt="Thumbnail"
              />
            </div>
          )}

          {/* Banner previews */}
          {bannerUrls.length > 0 && (
            <div className="m-0 d-flex flex-wrap gap-2">
              {bannerUrls.map((url, i) => (
                <div key={i} className="position-relative">
                  <img
                    className="border rounded bg-white p-1 mb-2"
                    width={100}
                    src={url}
                    alt="Banner"
                  />
                  <button
                    type="button"
                    className="btn btn-sm btn-danger position-absolute top-0 end-0"
                    onClick={() => removeBanner(i)}
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          )}

          <div className="col-6 m-0">
            <label>Travel Theme Name</label>
            <input
              className="form-control"
              type="text"
              required
              value={themeName}
              placeholder="Enter theme name"
              onChange={(e) => setThemeName(e.target.value)}
            />
          </div>

          <div className="col-3 m-0">
            <label>Thumbnail</label>
            <input
              type="file"
              accept="image/*"
              className="form-control"
              onChange={(event) => uploadThumbnail(event.target.files[0])}
            />
          </div>

          <div className="col-3 m-0">
            <label>Banner Images (Multiple)</label>
            <input
              multiple
              type="file"
              accept="image/*"
              className="form-control"
              onChange={(event) => uploadBanners(event.target.files)}
            />
          </div>

          {/* Overview input */}
          {/* <div className="col-12 m-0">
            <label>Overview</label>
            <textarea
              className="form-control"
              rows="4"
              placeholder="Write theme overview..."
              value={overview}
              onChange={(e) => setOverview(e.target.value)}
            ></textarea>
          </div> */}
          {/* Overview rich text editor */}
<div className="col-12 m-0">
  <label>Overview</label>
  <ReactQuill
    theme="snow"
    value={overview}
    onChange={setOverview}
    modules={modules}
    formats={formats}
    placeholder="Write theme overview..."
  />
</div>


          <div className="col-2 m-0">
            <button disabled={loading} className="btn btn-warning w-100 mt-3">
              {loading ? "Loading..." : editId ? "Update" : "Add"}
            </button>
          </div>

          {editId && (
            <div className="col-2 m-0">
              <button
                type="button"
                className="btn btn-secondary w-100 mt-3"
                onClick={resetForm}
              >
                Cancel
              </button>
            </div>
          )}
        </form>

        {/* Theme table */}
        <div className="w-100 mt-5 Mon_font">
          <table className="table border">
            <thead>
              <tr>
                <th>#</th>
                <th>Thumbnail</th>
                <th>Banner Images</th>
                <th>Theme Name</th>
                <th>Overview</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {allThemes &&
                allThemes.map((theme, index) => (
                  <tr key={theme?._id}>
                    <td>{index + 1}</td>
                    <td>
                      <img
                        width={120}
                        className="border p-2 rounded"
                        src={theme?.url}
                        alt="Thumb"
                      />
                    </td>
                    <td className="d-flex flex-wrap gap-2">
                      {theme?.bannerImages?.map((b, i) => (
                        <img
                          key={i}
                          width={120}
                          className="border p-2 rounded"
                          src={b}
                          alt="Banner"
                        />
                      ))}
                    </td>
                    <td>{theme?.name}</td>
                    <td style={{ maxWidth: "250px" }}>
                      <OverviewText text={theme?.overview || "-"} />
                    </td>
                    <td className="text-center d-flex gap-3 justify-content-center">
                      <EditIcon
                        className="text-primary"
                        style={{ cursor: "pointer" }}
                        onClick={() => editTheme(theme)}
                      />
                      <DeleteIcon
                        className="text-danger"
                        onClick={() => deleteTheme(theme?._id)}
                        style={{ cursor: "pointer" }}
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
};

export default AddTravelThemePage;
